// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__lL8qv","readonly":"checkbox_readonly__IWOuB","true":"checkbox_true__tqA5k","false":"checkbox_false__ceD8m","column":"checkbox_column__ccJYg"};